export type ProductKey =
  | "assess"
  | "Accounting"
  | "Banking"
  | "Commerce"
  | "syncForCommerce"
  | "syncForExpensesV1"
  | "syncForExpensesV2"
  | "bankFeeds"
  | "syncForPayroll"
  | "lending"
  | "payablesV1"
  | "payablesV2"
  | "spendInsights";

export const productIds = {
  syncForCommerce: "30acbb85-95f4-40b3-85c3-6f4e3bcc861f",
  Accounting: "f50e076d-0bd0-4d08-8c3c-18ed16cd9c9a",
  Banking: "5f2bbd95-1b70-4634-830d-247317cda94a",
  Commerce: "f25e20f3-8675-4915-877c-13327418466f",
  lending: "4e02a90f-e61c-463b-9aaf-55b0e5087792",
  assess: "4e02a90f-e61c-463b-9aaf-55b0e5087792", // left to support old onboarding flow
  syncForExpensesV1: "6fe9f97b-72cb-4898-9257-6187bee45b2d",
  syncForExpensesV2: "1c6d4d3a-fe5c-4ed4-9b15-9a29372aaba6",
  bankFeeds: "93c0effa-689a-4514-bfd7-e18b00b979e2",
  payablesV1: "bcd2816d-6397-44cc-abf4-7294adeca9e3",
  payablesV2: "b46dc6c8-57fa-41a4-94fd-448602c884fb",
  syncForPayroll: "944e6f52-851d-4c2e-a92f-71ff6af961c9",
  spendInsights: "6b427996-9e14-4d02-b58b-4a9ff8f1bf73",
} as const;

export const dashboardSupportedProductIds: string[] = [
  productIds.syncForCommerce,
  productIds.lending,
  productIds.syncForExpensesV1,
  productIds.syncForExpensesV2,
  productIds.bankFeeds,
  productIds.payablesV1,
  productIds.payablesV2,
  productIds.syncForPayroll,
  productIds.spendInsights,
];
